<section class="account-verify-email-view row">
  <div class="small-12 medium-8 medium-offset-2 columns">
    <h1>{{ title }}</h1>

    <div *ngIf="success" class="account-verify-email-success">
      <div>{{ 'account_verify_email_success' | translate }}</div>
      <aero-button
        [label]="'account_verify_email_success_action' | translate"
        (onClick)="goToProfile()">
      </aero-button>
    </div>

    <div *ngIf="!success" class="account-verify-email-failure">
      <div>{{ failureCode | translate }}</div>
      <div
        *ngIf="isAuthenticated"
        [innerHTML]="loggedInMessage"
        (click)="followAction($event)">
      </div>
      <div
        *ngIf="!isAuthenticated"
        [innerHTML]="anonymousMessage"
        (click)="followAction($event)">
      </div>
    </div>
  </div>
</section>
